import { gql } from "@apollo/client";

export const GET_BOOKING_INVOICE_STATUS = gql`
  query checkBookingInvoiceStatus($booking: String!, $status: [String!]) {
    checkBookingInvoiceStatus(booking: $booking, status: $status)
  }
`;
